// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "cc.bundle." + "c4962c8d96f91e22bfca" + ".js";
};